import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getAllLeads, Lead } from '../services/lead';

interface LeadSelectProps {
  value?: number;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
}

const LeadSelect: React.FC<LeadSelectProps> = ({
  value,
  onChange,
  placeholder = '选择关联线索',
  allowClear = true,
  disabled = false,
}) => {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');

  const fetchLeads = async (keyword?: string) => {
    setLoading(true);
    try {
      // Fetch all leads
      const response = await getAllLeads({
        page: 1,
        pageSize: 100,
        search: keyword,
      });

      setLeads(response.items);
    } catch (error) {
      console.error('Failed to fetch leads:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  const handleSearch = (value: string) => {
    setSearchKeyword(value);
    if (value) {
      fetchLeads(value);
    }
  };

  const handleChange = (selectedValue: number | undefined) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      allowClear={allowClear}
      disabled={disabled}
      loading={loading}
      showSearch
      filterOption={false}
      onSearch={handleSearch}
      style={{ width: '100%' }}
      notFoundContent={loading ? <Spin size="small" /> : '暂无线索'}
    >
      {leads.map((lead) => (
        <Select.Option key={lead.id} value={lead.id}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <UserOutlined />
            <span>{lead.contact_name}</span>
            {lead.phone && (
              <span style={{ color: '#999', fontSize: '12px' }}>
                {lead.phone}
              </span>
            )}
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default LeadSelect;
